import { buildAction } from 'store/actions/actionCreator'

import {
  CHANGE_DATA_SORTING,
  CHECK_REVENUE_FOR_TODAY,
  EXPAND_COUNTRY,
  FETCH_ALL_CLUSTERS,
  FETCH_ALL_STORES,
  FETCH_COUNTRY_CLUSTERS,
  FETCH_COUNTRY_STORES_LIST,
  FETCH_ECOM_CLUSTERS,
  FETCH_GENERAL_REVENUE,
  FETCH_STORE_DETAILS,
  FILTER_BY_CLUSTER,
} from './constants'

export const changeDataSorting = buildAction(CHANGE_DATA_SORTING, 'payload')
export const checkRevenueForToday = buildAction(CHECK_REVENUE_FOR_TODAY)
export const fetchAllClusters = buildAction(FETCH_ALL_CLUSTERS, 'fetchStoresType', 'dateCurrent', 'range')
export const fetchEcomClusters = buildAction(FETCH_ECOM_CLUSTERS)
export const fetchAllStores = buildAction(FETCH_ALL_STORES, 'fetchStoresType', 'dateCurrent', 'range')
export const fetchCountryClusters = buildAction(FETCH_COUNTRY_CLUSTERS, 'countryID', 'fetchStoresType')
export const fetchCountryStoresList = buildAction(FETCH_COUNTRY_STORES_LIST, 'countryID', 'fetchStoresType')
export const fetchGeneralRevenue = buildAction(FETCH_GENERAL_REVENUE, 'dateCurrent', 'range')
export const fetchStoreDetails = buildAction(FETCH_STORE_DETAILS, 'payload')
export const filterByCluster = buildAction(FILTER_BY_CLUSTER, 'countryID', 'cluster')
export const expandCountry = buildAction(EXPAND_COUNTRY, 'countryID')
